(function(){
  var KEY='wl_wishlist';
  var HEART='<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 4.6a5.5 5.5 0 00-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 00-7.8 7.8l1.1 1.1L12 21.2l7.7-7.7 1.1-1.1a5.5 5.5 0 000-7.8z"/></svg>';

  function get(){try{return JSON.parse(localStorage.getItem(KEY))||[]}catch(e){return[]}}
  function set(l){try{localStorage.setItem(KEY,JSON.stringify(l))}catch(e){}paint()}
  function has(h){return get().indexOf(h)>-1}
  function toggle(h){var l=get(),i=l.indexOf(h);i>-1?l.splice(i,1):l.push(h);set(l)}

  function handleFrom(href){
    if(!href)return null;
    var m=href.split('?')[0].split('/products/')[1];
    return m?m.split('/')[0]:null;
  }

  function makeBtn(h){
    var b=document.createElement('button');
    b.type='button';b.className='wl-btn';b.dataset.wlHandle=h;
    b.setAttribute('aria-label','Save to wishlist');
    b.innerHTML=HEART;
    return b;
  }

  function place(el,h){
    if(!el||el.querySelector('.wl-btn'))return;
    if(getComputedStyle(el).position==='static')el.style.position='relative';
    el.appendChild(makeBtn(h));
  }

  function inject(){
    var cur=location.pathname.indexOf('/products/')>-1?handleFrom(location.pathname):null;
    var SKIP='header,.header,nav,.mega-menu,cart-drawer,.cart-drawer,#CartDrawer,.drawer,.cart-notification,.wl-card';

    document.querySelectorAll('a[href*="/products/"]').forEach(function(a){
      var h=handleFrom(a.getAttribute('href'));
      if(!h||h===cur)return;
      if(!a.querySelector('img'))return;
      if(a.closest(SKIP))return;
      place(a,h);
    });

    if(cur&&!document.querySelector('.wl-btn[data-wl-main="1"]')){
      var gal=document.querySelector('media-gallery,.product__media-list,.product__media-wrapper,.product-media-container');
      if(!gal){
        var best=null,area=0;
        document.querySelectorAll('img').forEach(function(im){
          if(im.closest(SKIP))return;
          var r=im.getBoundingClientRect(),s=r.width*r.height;
          if(s>area&&r.width>200){area=s;best=im;}
        });
        if(best)gal=best.parentElement;
      }
      if(gal){
        place(gal,cur);
        var nb=gal.querySelector('.wl-btn');
        if(nb)nb.setAttribute('data-wl-main','1');
      }
    }

    header();
    paint();
  }

  function header(){
    if(document.querySelector('.wl-head-link'))return;
    var cart=document.querySelector('a[href*="/cart"]');
    if(!cart)return;
    var a=document.createElement('a');
    a.href='/pages/wishlist';a.className='wl-head-link';a.setAttribute('aria-label','Wishlist');
    a.innerHTML=HEART+'<span class="wl-badge" hidden>0</span>';
    cart.parentNode.insertBefore(a,cart);
  }

  function paint(){
    var l=get();
    document.querySelectorAll('.wl-btn').forEach(function(b){
      var on=l.indexOf(b.dataset.wlHandle)>-1;
      b.classList.toggle('wl-saved',on);
      b.setAttribute('aria-pressed',on);
      b.setAttribute('aria-label',on?'Remove from wishlist':'Save to wishlist');
    });    
    var bg=document.querySelector('.wl-badge');
    if(bg){bg.textContent=l.length;bg.hidden=l.length===0;}
  }

  document.addEventListener('click',function(e){
    var b=e.target.closest('.wl-btn');
    if(!b)return;
    e.preventDefault();e.stopPropagation();
    toggle(b.dataset.wlHandle);
    b.classList.add('wl-pop');setTimeout(function(){b.classList.remove('wl-pop')},200);
  },true);

  async function grid(){
    var g=document.getElementById('wl-grid');
    if(!g)return;
    var empty=document.getElementById('wl-empty'),l=get();
    if(!l.length){empty.hidden=false;return;}
    for(var h of l){
      try{
        var r=await fetch('/products/'+h+'.js');
        if(!r.ok){var c=get();c.splice(c.indexOf(h),1);set(c);continue;}
        var p=await r.json();
        var d=document.createElement('div');
        d.className='wl-card';d.dataset.wlCard=h;
        d.innerHTML='<a href="/products/'+p.handle+'"><img src="'+p.featured_image+'&width=500" alt=""><h3>'+p.title+'</h3></a>'+
          '<div class="wl-price">₹'+(p.price/100).toLocaleString('en-IN',{maximumFractionDigits:0})+'</div>'+
          '<button class="wl-remove" data-wl-rm="'+p.handle+'">Remove</button>';
        g.appendChild(d);
      }catch(e){}
    }
    if(!g.children.length)empty.hidden=false;
    paint();
  }

  document.addEventListener('click',function(e){
    var r=e.target.closest('[data-wl-rm]');
    if(!r)return;
    var h=r.dataset.wlRm,card=document.querySelector('[data-wl-card="'+h+'"]');
    toggle(h);
    if(card){card.classList.add('wl-out');setTimeout(function(){card.remove();
      var g=document.getElementById('wl-grid');
      if(g&&!g.children.length)document.getElementById('wl-empty').hidden=false;},300);}
  });

    var wlTimer=null,wlBusy=false;
  function scan(){
    if(wlBusy)return;
    wlBusy=true;
    try{inject()}catch(e){}
    setTimeout(function(){wlBusy=false},50);
  }
  function boot(){
    if(window.Shopify&&window.Shopify.designMode){inject();grid();return;}
    scan();grid();
    new MutationObserver(function(){
      if(wlTimer)return;
      wlTimer=setTimeout(function(){wlTimer=null;scan()},500);
    }).observe(document.body,{childList:true,subtree:true});
  }
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',boot):boot();
})();